import React from 'react';
import { Button, Row, Col, Spinner, Container, ButtonGroup } from 'reactstrap';
import Block from '../common/Display/Block';
import MenuNavBottom from '../common/MenuNavBottom';
import '../../assets/scss/react-datepicker.css';
import RecordsResults from './RecordsResults';
import { useRecordList } from '../../hooks/useForm/useRecordList';
import QuantityBadge from './QuantityBadge';
import Translate, { t } from '../common/Translate';
import dashboardIcon from '../../assets/img/dashboard.svg';
import AutobizStrapPopup from '../common/Modal/AutobizStrapPopup';

const RecordsList = (props) => {
  const { records, loading, error, tabs, refresh, currentPage, goToPage, pageCount, currentTab } = useRecordList(props);
  return (
    <Block {...props} noBack>
      <AutobizStrapPopup />
      <h1 className="page-title">
        <span className="cursor-pointer">
          <img src={dashboardIcon} alt="" height="25" /> {t('dashboard')}
        </span>
        <button type="button" onClick={refresh} className={`btn refresh-button btn-3 ${loading ? 'loading' : ''}`}>
          {loading && <Spinner size="sm" className="spinner-loader" />}
          <Translate code="refresh" />
        </button>
      </h1>
      <div className="filters-results-container">
        <Container fluid>
          <Row>
            <Col xs="12" className="switch-dashboard">
              <ButtonGroup className="d-block">
                {tabs.map(({ count, onClick, selected, name, type }) => (
                  <Button onClick={onClick} color="primary" outline={!selected} key={type}>
                    {' '}
                    {name}
                    <QuantityBadge count={count} />
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
          </Row>
          <Row>
            <RecordsResults
              loading={loading}
              forms={records}
              error={error}
              origin="forms"
              currentTab={currentTab}
              currentPage={currentPage}
              pageNumbers={pageCount}
              changePaginationIndex={goToPage}
            />
          </Row>
        </Container>
      </div>
      <MenuNavBottom active="dashboard" />
    </Block>
  );
};

RecordsList.propTypes = {
  // origin: PropTypes.string.isRequired,
};

export default RecordsList;
